import React from "react";
import ChoiceCheck from "./ChoiceCheck";
import Footer from "./Footer";

export default function App() {
  return (
    <div className="App">
      <h1>NPC Assembly v0.4</h1>
      <ChoiceCheck />
      <Footer />
    </div>
  );
}
